function isUndefined (value) {
  return typeof value === 'undefined'
}

module.exports = isUndefined



//////////////////
// WEBPACK FOOTER
// ./~/react-faux-dom/lib/utils/isUndefined.js
// module id = 1044
// module chunks = 0